import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import { showToast } from "@/api/notification";
import { Eye, EyeOff } from "lucide-react"; // 👈 import icons

function FirstTimeLogin() {
  const navigate = useNavigate();
  const { postApi, error, loading } = useGeneralApiCall();

  const [email, setEmail] = useState<string>("");
  const [systemPassword, setSystemPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  // 👇 password visibility states
  const [showSysPass, setShowSysPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  // const location = useLocation();
  // const resetToken = location.pathname.split("/").filter(Boolean)[1];

  const handleData = async (e: any) => {
    e.preventDefault();
    try {
      const response: any = await postApi(
        `/api/auth/v1/change-system-password/`,
        {
          username: email,
          old_password: systemPassword,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }
      );

      if (response.status === 200 || response.status === 201) {
        showToast({ message: response.message, type: "success" });
        navigate("/");
      }
    } catch (error: any) {
      showToast({ message: error.message, type: "error" });
    }
  };

  return (
    <div className="login-background !text-[25px]">
      <div className="login-card-first">
        <h2 className="!text-[25px]">First Time Login Password Change</h2>
        <form onSubmit={handleData}>
          <label>User Name</label>
          <input
            type="text"
            placeholder="Enter username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="placeholder:!text-[16px] !text-[16px]"
          />

          {/* System Generated Password */}
          <label>System Generated Password</label>
          <div className="relative">
            <input
              type={showSysPass ? "text" : "password"}
              placeholder="Enter password"
              value={systemPassword}
              onChange={(e) => setSystemPassword(e.target.value)}
              className="placeholder:!text-[16px] !text-[16px] pr-10 w-full"
            />
            <button
              style={{
                width: "10px",
                backgroundColor: "transparent",
                color: "black",
              }}
              type="button"
              onClick={() => setShowSysPass(!showSysPass)}
              className="absolute right-4 top-1/4 -translate-y-1/2 p-1 bg-transparent text-gray-600"
            >
              {showSysPass ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {/* New Password */}
          <label>New Password</label>
          <div className="relative">
            <input
              type={showNewPass ? "text" : "password"}
              placeholder="Enter password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="placeholder:!text-[16px] !text-[16px] pr-10 w-full"
            />
            <button
              style={{
                width: "10px",
                backgroundColor: "transparent",
                color: "black",
              }}
              type="button"
              onClick={() => setShowNewPass(!showNewPass)}
              className="absolute right-5 top-1/4 -translate-y-1/2 p-1 bg-transparent text-gray-600"
            >
              {showNewPass ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {/* Confirm New Password */}
          <label>Confirm New Password</label>
          <div className="relative">
            <input
              type={showConfirmPass ? "text" : "password"}
              placeholder="Enter password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="placeholder:!text-[16px] !text-[16px] pr-10 w-full"
            />
            <button
              style={{
                width: "10px",
                backgroundColor: "transparent",
                color: "black",
              }}
              type="button"
              onClick={() => setShowConfirmPass(!showConfirmPass)}
              className="absolute right-5 top-1/4 -translate-y-1/2 p-1 bg-transparent text-gray-600"
            >
              {showConfirmPass ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type="submit" className="hover:!bg-green-600 mt-3">
            {loading ? "Submitting..." : "Change Password"}
          </button>
        </form>

        <p className="mt-2 text-red-900">{error}</p>

        <div className="login-links !text-[20px]">
          <Link to="/">Login</Link>
        </div>
      </div>
    </div>
  );
}

export default FirstTimeLogin;
